module.exports = __webpack_public_path__ + "img/logo-vtexlegacy.af219bb0.svg";